import { Component, inject, OnInit } from '@angular/core';
import { AvatarModule } from 'primeng/avatar';
import { MenuModule } from 'primeng/menu';
import { ButtonModule } from 'primeng/button';
import { MenuItem } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { ThemeSwitcherComponent } from '../../atoms/theme-switcher/theme-switcher.component';
import { ActiveUserStore } from '../../../stores/user/active-user.state';
import { GlobalSearchComponent } from '../global-search/global-search.component';
import { NotificationButtonComponent } from '../../atoms/notification-button/notification-button.component';
import { GlobalsStore } from '../../../stores/globals.state';
import { ActiveUserAvatarComponent } from '../../atoms/active-user-avatar/active-user-avatar.component';
import { ValidationBadgeComponent } from '../../atoms/validation-badge/validation-badge.component';
@Component({
  selector: 'app-top-bar',
  standalone: true,
  imports: [
    AvatarModule,
    MenuModule,
    ButtonModule,
    ToastModule,
    ThemeSwitcherComponent,
    GlobalSearchComponent,
    NotificationButtonComponent,
    ActiveUserAvatarComponent,
    ValidationBadgeComponent,
  ],
  templateUrl: './top-bar.component.html',
  styleUrl: './top-bar.component.scss',
})
export class TopBarComponent implements OnInit {
  readonly userStore = inject(ActiveUserStore);
  readonly globalsStore = inject(GlobalsStore);
  items: MenuItem[] | undefined;
  adderItems: MenuItem[] | undefined; // todo - use at menu?

  ngOnInit(): void {
    this.items = [
      {
        label: 'Dashboard',
        icon: 'fas fa-laptop',
        target: '_blank',
        routerLink: ['/dashboard'],
      },
      {
        label: 'Internen Atlas aufrufen',
        icon: 'fas fa-house-user',
        target: '_blank',
        routerLink: ['/atlas-intern'],
      },
      {
        label: 'Öffentlichen Atlas aufrufen',
        icon: 'fas fa-earth-europe',
        target: '_blank',
        routerLink: [`/atlas/${this.userStore.commune()}`],
      },
      {
        url: 'https://www.youtube.com/playlist?list=PLxyQdUGjPEsF8ZEsi47HHpQRI6-v-8owD',
        target: '_blank',
        label: 'Erklärvideos',
        icon: 'fa-brands fa-youtube',
        sub: 'Veraltetes Design, aber die Funktionen bleiben weitestgehend gleich. Neue Videos folgen!',
      },
      {
        label: 'Verlauf',
        icon: 'fas fa-clock-rotate-left',
        routerLink: ['/data-backend', { outlets: { overlay: 'historie' } }],
      },
      //{
      //  label: 'Logout',
      //  icon: 'fa fa-right-from-bracket',
      //  command: () => {
      //    this.logout();
      //  },
      //},
    ];
  }

  /**
   * Logs out the current user by invoking the logout method of the user store.
   *
   * @return {void} Does not return a value.
   */
  logout(): void {
    this.userStore.logout();
  }
}
